module.exports = __webpack_public_path__ + "static/media/work-bg-3.b6dcd7b9.jpg";